import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { QUERIES } from '@/constants/queries'
import { getStudentDesiredducationCoursesByRequest } from '@/services/requests/get-student-desired-education-courses-by-request'
import type { DesiredEducationCourse } from '@/types/education/desired-education-course'
import type { Request } from '@/types/requests/request'

export const useCheckTheEquivalences = (request?: Request) => {
  const [selectedCollegeCourses, setSelectedCollegeCourses] = useState<
    DesiredEducationCourse[]
  >([])

  const {
    data: studentDesiredCourses,
    isFetching: isStudentDesiredCoursesPending
  } = useQuery({
    queryKey: [
      QUERIES.QUERY_GET_STUDENT_DESIRED_EDUCATION_COURSES_BY_REQUEST,
      request?.id
    ],
    queryFn: () => getStudentDesiredducationCoursesByRequest(request?.id),
    enabled: !!request?.id
  })

  const isPageLoading = isStudentDesiredCoursesPending

  return {
    states: { isPageLoading, studentDesiredCourses, selectedCollegeCourses },
    actions: { setSelectedCollegeCourses }
  }
}
